module.exports = __webpack_public_path__ + "static/media/brass.57758aeb.png";